import DynamicService from "@/services/commons/DynamicService";

const fetch = (context, params) => {
  return DynamicService.fetch('rrhh', 'buzon-sugerencias', params)
    .then(res => {
      context.commit('BUZON_SUGERENCIAS', res.data);
    });
};

export default {
  fetch,
};